export default __webpack_public_path__ + "static/char-s-07-jp-67d4c405b71b0e911d69e067ca4c5b84.webp";